/* src/app/components/company/company.component.css */
/*# sourceMappingURL=company.component.css.map */
